import { Box } from '@mui/system'
import i18n from 'i18next'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PositionsContent from './PositionsContent'
import PositionsHeader from './PositionsHeader'
import { useDefaultComponentTools } from '../../../../hooks/useDefaultComponentTools'
import { getNewsData } from '../../../../store/redusers/positions/actions'
import { selectUserId } from '../../../../store/redusers/user/selectors'
import { getSimpleLang } from '../../../../helpers'

const Positions = () => {
	const { dispatch, mdUp } = useDefaultComponentTools(true)
	const isAuthorized = useSelector(selectUserId)
	useEffect(() => {
		dispatch(getNewsData(getSimpleLang(i18n.language) || 'en'))
	}, [dispatch, isAuthorized, i18n.language])
	const [headerHeight, setHeaderHeight] = useState(64)

	return (
		<Box sx={{display: 'flex', flexDirection: 'column', gap: mdUp ? '16px' : '8px', height: '100%'}}>
			<PositionsHeader setHeaderHeight={setHeaderHeight}/>
			<PositionsContent headerHeight={headerHeight}/>
		</Box>
	)
}

export default Positions
